import { listStyleTypeMap } from './conf.js';
// 获取 ol 的 list-style-type 属性值
export const getListStyleType = (node) => {
    let listStyleType = node.getAttribute('data-list-style-type') || node.style.listStyleType;
    if (listStyleType && listStyleType !== 'none') {
        return listStyleType;
    }
    listStyleType = node.getAttribute('type');
    if (listStyleType) {
        return listStyleTypeMap[listStyleType];
    }
    return null;
};
//# sourceMappingURL=util.js.map